import React, { useEffect, useState } from "react";
import { Get } from "../../../../utils/request";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import Board from "../Card";
import SkeletonCardList from "modules/LoadingPlaceholders/Skeletons/SkeletonCardList";
import { Container, Typography } from "@mui/material";

const DisplayCourses = (props) => {
  const [mui_theme, setMuiTheme] = useState({});
  const [listed_courses, setListedCourses] = useState([]);
  const [categories, setCategories] = useState([]);

  const userId = useSelector((store) => store.AppReducer.user.id);
  const loginTheme = useSelector(
    (store) => store.StylesReducer.pagesThemes?.mural_cursos
  );

  useEffect(() => {
    setMuiTheme(loginTheme?.palette?.data);
  }, [loginTheme]);

  const [isLoading, setLoading] = useState(true);
  // const { data, error, refetch } = useQuery("categories", async () => {
  //   // setLoading(true);
  //   let data = await Get(`courses-main/category?userId=${userId}`);
  //   setLoading(false);

  //   return data;
  // });
  // const { categories } = data || {};

  // const listedCourses = useQuery("my-list", async () => {
  //   let data = await Get(`user-list-course?userId=${userId}`);
  //   setLoading(false);
  //   return data;
  // });

  const getCategories = async () => {
    await Get(`courses-main/category?userId=${userId}`).then((res) => {
      setCategories(res.categories);
      setLoading(false);
    });
  };

  useEffect(() => {
    getCategories();
  }, []);

  const getMyList = async () => {
    await Get(`user-list-course?userId=${userId}`).then((res) => {
      console.log(res);
      let temp_list = [];
      res?.list.map((course) => {
        temp_list.push(course.course_id);
      });
      setListedCourses(temp_list);
      console.log(temp_list);
    });
  };

  useEffect(() => {
    getMyList();
  }, []);

  if (isLoading)
    return (
      <Container maxWidth="xl" sx={{ padding: "0", paddingTop: "2rem" }}>
        <SkeletonCardList />
      </Container>
    );

  return (
    !isLoading && (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "2rem",
          backgroundColor: mui_theme.background_color,
          minHeight: "100vh",
          padding: "1.25rem 0 2rem",
        }}
      >
        {categories?.map((category, index) => {
          return (
            category?.courses?.length !== 0 && (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "0.6rem 1rem",
                }}
              >
                <Typography
                  variant="h4"
                  style={{
                    display: "flex",
                    gap: "0.2rem",
                    alignItems: "center",
                    fontWeight: "bold",
                    paddingLeft: "0.5rem",
                    color: mui_theme.font_color,
                  }}
                >
                  {category.name}
                </Typography>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(18rem, 1fr))",
                    gap: "1rem",
                    alignItems: "start",
                    paddingTop: "0.8rem",
                  }}
                >
                  {category?.courses?.map((course, index2) => {
                    if (course?.lessons?.length !== 0)
                      return (
                        <Board
                          key={index2}
                          {...course}
                          isUserIn={course?.usercourse !== null}
                          fontColor={mui_theme.font_color}
                          listed_courses={listed_courses}
                        />
                      );
                  })}
                </div>
              </div>
            )
          );
        })}
      </div>
    )
  );
};

export default DisplayCourses;
